import { useEffect, useState } from "react"


export const GUARD_NAME_MIN = 4;
export const GUARD_NAME_MAX = 20;
export const AFFAIR_DESCRIPTION_MIN = 5;
export const AFFAIR_DESCRIPTION_MAX = 2048;
export const AFFAIR_TITLE_MIN = 5;
export const AFFAIR_TITLE_MAX = 200;


export function useDebounce<T>(value: T, delay?: number): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value)

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay || 500)

		return () => {
			clearTimeout(timer)
		}
	}, [value, delay])

	return debouncedValue
}

//https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
export function useOutsideAlerter(ref, cb) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				cb();
			}
		}
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, cb]);
}



export function formatDateTime(dateOrString: Date | string | undefined) {
	if (typeof dateOrString === 'string')
		dateOrString = new Date(dateOrString);
	if (dateOrString && typeof dateOrString === 'object' && dateOrString['toLocaleString'])
		return dateOrString.toLocaleString("hu-HU", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit"
		});
	else
		return 'N/A';
}

export function formatDate(dateOrString: Date | string | undefined) {
	if (typeof dateOrString === 'string')
		dateOrString = new Date(dateOrString);
	if (dateOrString && typeof dateOrString === 'object' && dateOrString['toLocaleDateString'])
		return dateOrString.toLocaleDateString("hu-HU"); 
	else
		return 'N/A';
}
export function toSqlDate(f: Date): string {
	var mm = f.getMonth() + 1; // getMonth() is zero-based
	var dd = f.getDate();

	return [f.getFullYear(), '-',
	(mm > 9 ? '' : '0') + mm, '-',
	(dd > 9 ? '' : '0') + dd
	].join('');
}

export function splitToWords(txt: string) {
	const words = txt.toLowerCase().match(/\p{L}[\p{L}\p{N}]*/gu) || [];
	return words;
}

export function removeHungarianAccents(txt: string) {
	const map: any = {
		á: "a", Á: "a",
		é: "e", É: "e",
		í: "i", Í: "i",
		ó: "o", Ó: "o",
		ö: "o", Ö: "o",
		ő: "o", Ő: "o",
		ú: "u", Ú: "u",
		ü: "u", Ü: "u",
		ű: "u", Ű: "u",
	};
	return txt.replace(/[\u00C0-\u017F]/g, ch => map[ch] || ch);
}